export const getLinkReductionUnits = (conversionType) => {
  if (!conversionType?.unitName) return [];
  if (conversionType.unitRestrictions || !conversionType.smallUnitName)
    return [conversionType.unitName];
  return [conversionType.unitName, conversionType.smallUnitName];
};

export const getLinkRateCardDisabledReason = (rateCard, sourceRateCardId) => {
  if (rateCard?.id && sourceRateCardId && rateCard.id === sourceRateCardId)
    return "Current source Rate Card";
  if (!rateCard?.conversionType?.unitName)
    return "Conversion Type required";
  return "";
};
